import { Link, Text } from '@chakra-ui/react';

import { formatMetricDate } from './PublicMetricsShared';

export function SourceCell({ value }) {
    const label = [value?.form, formatMetricDate(value?.filing_date)].filter(Boolean).join(' ');
    if (value?.source_url) {
        return (
            <Link href={value.source_url} target="_blank" rel="noopener noreferrer" color="blue.600">
                {label || value.source_label || 'Source filing'}
            </Link>
        );
    }
    if (value?.accession_number) {
        return <Text as="span">{value.accession_number}</Text>;
    }
    return <Text as="span" color="gray.500">n/a</Text>;
}
